import { Grid, Typography } from '@mui/material'
import { Consumer as AppConsumer } from 'platform/react/context/guest'
import { useMemoRef, useStyles } from 'platform/react/hook'

const styles = theme => ({
  ...theme.custom.actionTitle,
})

/**
 * ActionTitle component
 *
 * Displays the title of the current action (action.ui.title).
 *
 * @param {Object} classes
 * @param {string} title
 * @returns {JSX.Element}
 */
const ActionTitle = ({ title }) => {
  const classes = useStyles(styles)()
  return (
    <Grid
      item
      alignContent={'center'}
      flexShrink={1}
      xs={12}
    >
      <AppConsumer>
        {() => (
          <Typography
            className={classes.title}
            variant={'20/bold'}
            noWrap={true}
          >
            {title}
          </Typography>
        )}
      </AppConsumer>
    </Grid>
  )
}

export default useMemoRef(ActionTitle, props => [props.update])
